import { createAction } from 'redux-actions';

export const NAMES = {
  SET: 'CLIENT.SELECTED_VIDEO.SET',
  RESET: 'CLIENT.SELECTED_VIDEO.RESET',
};

export const selectVideo = createAction(NAMES.SET);
export const resetSelectedVideo = createAction(NAMES.RESET);



// WEBPACK FOOTER //
// ./src/widget/redux/client/actions/select-video.js